<template>
  <Transition
    name="expand"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
  >
    <slot></slot>
  </Transition>
</template>

<script>
export default {
  name: 'HeightTransition',

  methods: {
    enter(element) {
      const el = element;

      el.style.width = getComputedStyle(el).width;
      el.style.position = 'absolute';
      el.style.visibility = 'hidden';
      el.style.height = 'auto';

      const { height } = getComputedStyle(el);

      el.style.width = null;
      el.style.position = null;
      el.style.visibility = null;
      el.style.height = 0;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          el.style.height = height;
        });
      });
    },

    afterEnter(element) {
      const el = element;
      el.style.height = 'auto';
    },

    beforeLeave(element) {
      const el = element;

      el.style.height = getComputedStyle(el).height;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          el.style.height = 0;
        });
      });
    },
  },
};
</script>

<style>
.expand-enter-active,
.expand-leave-active {
  transition-property: opacity, height;
  transition: all 0.2s ease-in-out;
  overflow: hidden;
}
</style>
